<template>
  <div>
    <div @click="paymentRecievedDialog = true" v-if="btn !== false">
      <slot />
    </div>
    <v-dialog
      v-model="paymentRecievedDialog"
      scrollable
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      @keydown.esc="closePaymentRecievedDialog(false)"
    >
      <v-card>
        <v-toolbar dark color="primary" max-height="60">
          <h3>{{ label }}</h3>
          <v-btn
            v-if="payment_loading == true"
            class="text-center"
            text
            fab
            color="white"
            :loading="payment_loading"
          ></v-btn>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closePaymentRecievedDialog(false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <payment-received-edit
            :singlePage="true"
            @closeDialog="closePaymentRecievedDialog"
            :client_id="client_id"
            :clientEntity_id="clientEntity_id"
            :collectEdit_id="collectEdit_id"
            :date="date"
            :against="2"
            :pendingAmount="pendingAmount"
            :paidAmount="paidAmount"
            :itemTotalAmount="itemTotalAmount"
            :trip="trip"
            :trip_id="trip ? trip._id : null"
            :invoice="invoice"
            :hideInvoices="hideInvoices"
            :hideTrips="hideTrips"
            @setLoading="setLoading"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import PaymentReceivedEdit from "@/views/paymentreceived/PaymentReceivedEdit.vue";

@Component({
  name: "PaymentReceivedCreate",
  components: {
    PaymentReceivedEdit,
  },
  props: {
    label: {
      default: "Payment Received",
    },
    collectEdit_id: {
      default: null,
    },
    client_id: {
      default: null,
    },
    clientEntity_id: {
      default: null,
    },
    date: {
      default: null,
    },
    pendingAmount: {
      default: null,
    },
    paidAmount: {
      default: null,
    },
    itemTotalAmount: {
      default: null,
    },
    trip: {
      default: null,
    },
    invoice: {
      default: null,
    },
    btn: {
      default: false,
    },
    hideTrips: {
      default: null,
    },
    hideInvoices: {
      default: null,
    },
  },
})
export default class PaymentReceivedCreate extends Vue {
  paymentRecievedDialog = false;
  payment_loading = false;

  closePaymentRecievedDialog(reload) {
    this.paymentRecievedDialog = false;
    this.$emit("reload", reload);
  }

  setLoading(loading) {
    this.payment_loading = loading;
  }
}
</script>
